"use client"

import { Pocket } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PocketIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PocketIcon = component(Icon)({ as: Pocket })
